<template>
  <toggle-panel
    :title="$t('grade.title')"
    :disabled="false"
    :value="rating.selected"
    @click="$emit('click')"
  >
    <base-icon
      slot="icon"
      name="basic_star"
    />
    <div v-if="rating.selected" slot="content">
      <labeled-input
        v-model="question"
        :label="$t('grade.question.input.label')"
        :placeholder="$t('grade.question.input.placeholder')"
        :maxlength="255"
        use-counter
      />

      <div v-m-t="30" :class="$style.section">
        <h3
          v-m-b="10"
          :class="$style.title"
          v-text="$t('grade.target.title')"
        ></h3>

        <div v-m-b="20" :class="$style.content">
          <div
            :class="[$style.preview, { [$style.active]: type === 'star' }]"
            @click="type = 'star'"
          >
            <rating-preview :active="type === 'star'" type="star" />
            <p v-m-t="10" v-text="$t('grade.target.starts')"></p>
          </div>

          <div
            :class="[$style.preview, { [$style.active]: type === 'heart' }]"
            @click="type = 'heart'"
          >
            <rating-preview :active="type === 'heart'" type="heart" />
            <p v-m-t="10" v-text="$t('grade.target.hearts')"></p>
          </div>
        </div>

        <simple-button variant="primary" @click="handleSubmit">
          {{ $t('common.save') }}
        </simple-button>
      </div>
    </div>
  </toggle-panel>
</template>

<script>
import TogglePanel from 'molecules/panels/TogglePanel';
import LabeledInput from 'molecules/common/LabeledInput';
import SimpleButton from 'molecules/common/SimpleButton';
import RatingPreview from 'molecules/rating/RatingPreview';

const DEFAULT_TYPE = 'star';

export default {
  name: 'PaymentGrade',
  components: {
    TogglePanel,
    LabeledInput,
    SimpleButton,
    RatingPreview,
  },
  props: {
    rating: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      question: '',
      type: DEFAULT_TYPE,
    };
  },
  watch: {
    rating: {
      deep: true,
      immediate: true,
      handler(val) {
        this.fillingData(val);
      },
    },
  },
  methods: {
    fillingData(data) {
      this.question = data?.question || '';
      this.type = data?.type || DEFAULT_TYPE;
    },
    handleSubmit() {
      this.$emit('submit', {
        ...this.rating,
        question: this.question,
        type: this.type,
      });
    },
  },
};
</script>

<style lang="sass" module>
  .section
    position: relative

  .title
    +font-type('semi-bold', 16, 20);

  .content
    display: grid
    grid: 1fr / 1fr 1fr
    grid-gap: 10px

  .preview
    +font-type('semi-bold', 12, 15)
    padding: 20px
    background-color: #27283C
    box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15)
    border: 1px solid transparent
    border-radius: 5px
    cursor: pointer

    &.active
      background-color: #2E3048
      border-color: #43455A
      cursor: default

    +hover
      border-color: #43455A
</style>
